import * as React from 'react';
import { CTA } from '../../../components/CTA';
import { __ } from '../../../helpers/TranslationService';

const style: Record<string, React.CSSProperties> = {
    title: {
        margin: '10px 0px',
    },
    CTAButton: {
        margin: '0 20px',
        fontSize: 19,
    },
    noFavorites: {
        fontWeight: 'bold',
        fontSize: 17,
        textAlign: 'center',
        padding: 10,
        paddingBottom: 25,
        margin: 0,
    },
};

interface IProps {
    doNewSearchViaUrl: Function;
    clearFilterParams: Function;
}
export const NoFavorites = (props: IProps) => {
    const newSearch = () => {
        props.clearFilterParams(false);
        props.doNewSearchViaUrl();
    };

    return (
        <div style={style.noFavorites}>
            <p style={style.title}>{__("You haven't saved any favorites yet", 'dreamlines')}</p>
            <CTA onClick={newSearch} wrapperStyle={style.CTAButton}>
                <span>{__('Search cruise', 'dreamlines')} </span>
            </CTA>
        </div>
    );
};
